/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 public/meshes/Coolant_3v0.glb -o src/meshes/Coolant_3v0.tsx -r public -t -k -s -p 7 
Modified by: Aeroplane GLTFJSX Generator v1.9.1
*/

import { Group, Mesh, MeshStandardMaterial } from "three";
import { forwardRef, ForwardedRef, useEffect, useImperativeHandle, ForwardRefExoticComponent, useRef } from "react";
import { useGLTF } from "@react-three/drei";
import useM_Coolant from "@materials/M_Coolant";
import { GLTFJSXUtils } from "@utils/GLTFJSXUtils";
import { GLTF } from "three-stdlib";
import { ObjectUtils } from "@utils/ObjectUtils";
import { assetPath } from "@utils/Config";

const mesh = assetPath("/meshes/Coolant_3v0.glb");

type GLTFResult = GLTF & {
    nodes: {
        Coolant: Mesh;
    }
    materials: {
        M_Coolant: MeshStandardMaterial;
    }
}

export type Handle = {
    root: Group | null;
    meshes: GLTFResult["nodes"];
};
export function useHandle(ref: ForwardedRef<Group>) {
    const handle = useRef<Handle>(null);
    useEffect(() => {
        if (!ref) return;
        if (typeof ref === "function") ref(handle.current?.root ?? null);
        else ref.current = handle.current?.root ?? null;
    }, [handle, ref]);
    return handle;
};
export default forwardRef<Handle, JSX.IntrinsicElements["group"]>(function Model(props, ref) {
    const group = useRef<Group>(null);
    const { nodes, materials } = useGLTF(mesh) as GLTFResult;
    const M_Coolant = useM_Coolant();
    useImperativeHandle(ref, () => GLTFJSXUtils.createHandle<Handle>({ root: group.current }, nodes), [group, nodes]);
    return (
        <group ref={group} {...props} dispose={null}>
            <mesh name="Coolant" receiveShadow={props.receiveShadow} castShadow={props.castShadow} {...ObjectUtils.pick(nodes.Coolant, "geometry", "morphTargetDictionary", "morphTargetInfluences")} material={M_Coolant} scale={129.0486603} raycast={props.raycast} renderOrder={props.renderOrder} />
        </group>
    );
});

useGLTF.preload(mesh, true, true);
